// removed by extract-text-webpack-plugin
module.exports = {"box":"_1yIoSG-7FfoDt-IJKNuQAH","item":"_1OpwZPXBjDMnqU_bHEc1lx"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/TestimonialsSlider.scss
// module id = 1570
// module chunks = 0